import { useGoldenImages } from '@/hooks/useInfra'
import type { ImageChoice, ImageComponent, InfraProduct } from '@/types/infrastructure'
import { LookupSelect } from './LookupSelect'

interface GoldenImageSelectProps {
  product: InfraProduct
  regionId: string
  /** Which machine the image is for. Today every component shares the main list; see infraMock.ts. */
  component?: ImageComponent
  value: ImageChoice | null
  onChange: (value: ImageChoice | null) => void
  label?: string
  idPrefix: string
  problem?: string | null
}

/** Golden images for the product in the chosen region. Disabled until a region is chosen. */
export function GoldenImageSelect({ product, regionId, component = 'main', value, onChange, label = 'Golden image', idPrefix, problem }: GoldenImageSelectProps) {
  const images = useGoldenImages(product, regionId, component)
  return (
    <LookupSelect
      id={`${idPrefix}-image`}
      label={label}
      required
      value={value?.id ?? ''}
      options={(images.data ?? []).map((image) => ({ value: image.id, label: image.name }))}
      onChange={(id) => {
        const image = (images.data ?? []).find((item) => item.id === id)
        onChange(image ? { id: image.id, name: image.name } : null)
      }}
      waitingFor={regionId ? undefined : 'a region'}
      isLoading={images.isLoading}
      isError={images.isError}
      onRetry={() => void images.refetch()}
      emptyMessage={`No golden images available for ${product.name} in this region.`}
      problem={problem}
    />
  )
}
